import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import { ButtonInLink } from '@hivebrite/design-system/ButtonInLink';
import { useToggle } from '@hivebrite/react-hooks';

import EndRelationshipModal from 'hb-react/frontoffice/apps/Mentoring/components/EndRelationshipModal';
import type {
  Program,
  SharedCardProfile,
} from 'hb-react/frontoffice/apps/Mentoring/types';
import { useShouldDisplayInternalMessagingAction } from 'hb-react/frontoffice/utils/messaging';

interface AcceptedProps {
  relationshipWithCurrentUser: SharedCardProfile['relationship_with_current_user'];
  program: Program;
  userId: number;
}

const Accepted = ({
  relationshipWithCurrentUser,
  userId,
  program,
}: AcceptedProps) => {
  const { isOpen, open, close } = useToggle();
  const displayMessagingButton = useShouldDisplayInternalMessagingAction({
    user: { id: userId },
  });

  const displayEndRelationshipButton = !!relationshipWithCurrentUser?.id;
  const hasTwoButtons = !!(
    displayEndRelationshipButton && displayMessagingButton
  );

  return (
    <Actions $hasTwoButtons={hasTwoButtons}>
      {displayEndRelationshipButton && (
        <>
          <Button variant="secondary" onClick={open}>
            {s__('Mentoring|End relationship')}
          </Button>
          {isOpen && (
            <EndRelationshipModal
              onCloseModal={close}
              program={program}
              relationshipId={relationshipWithCurrentUser.id}
            />
          )}
        </>
      )}
      {displayMessagingButton && (
        <ButtonInLink
          linkProps={{
            to: Routes.messaging_new_conversation_path({
              recipient_ids: userId,
            }),
          }}
          wrapperProps={{ style: { flexGrow: 1 } }}
        >
          {s__('Mentoring|Send message')}
        </ButtonInLink>
      )}
    </Actions>
  );
};

export default Accepted;

const Actions = styled(Box)<{ $hasTwoButtons: boolean }>`
  flex-flow: ${({ $hasTwoButtons }) => ($hasTwoButtons ? 'row wrap' : 'row')};
  flex-grow: 0;
  margin-top: auto;
  padding-top: ${({ theme }) => `${theme.space[4]}px`};
  gap: ${({ theme }) => `${theme.space[3]}px`};

  > button,
  > div > a,
  > div > a > span {
    flex-grow: ${({ $hasTwoButtons }) => ($hasTwoButtons ? 1 : 0)};
  }
`;
